// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__gtYZb","question":"Question_question__aPwM0","description":"Question_description__1-B3T"};